<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M7.3999 8.60002V10.6C7.3999 10.77 7.45706 10.9125 7.57139 11.0275C7.68572 11.1425 7.82739 11.2 7.99639 11.2C8.1654 11.2 8.30824 11.1425 8.4249 11.0275C8.54157 10.9125 8.5999 10.77 8.5999 10.6V8.60002H10.5999C10.7699 8.60002 10.9124 8.54286 11.0274 8.42854C11.1424 8.31421 11.1999 8.17254 11.1999 8.00354C11.1999 7.83453 11.1424 7.69169 11.0274 7.57502C10.9124 7.45836 10.7699 7.40002 10.5999 7.40002H8.5999V5.40002C8.5999 5.23002 8.54274 5.08752 8.42842 4.97252C8.31409 4.85752 8.17242 4.80002 8.00342 4.80002C7.83441 4.80002 7.69157 4.85752 7.5749 4.97252C7.45824 5.08752 7.3999 5.23002 7.3999 5.40002V7.40002H5.3999C5.2299 7.40002 5.0874 7.45719 4.9724 7.57151C4.8574 7.68584 4.7999 7.82751 4.7999 7.99651C4.7999 8.16552 4.8574 8.30836 4.9724 8.42502C5.0874 8.54169 5.2299 8.60002 5.3999 8.60002H7.3999ZM3.5999 13.6C3.2699 13.6 2.9874 13.4825 2.7524 13.2475C2.5174 13.0125 2.3999 12.73 2.3999 12.4V3.60002C2.3999 3.27002 2.5174 2.98752 2.7524 2.75252C2.9874 2.51752 3.2699 2.40002 3.5999 2.40002H12.3999C12.7299 2.40002 13.0124 2.51752 13.2474 2.75252C13.4824 2.98752 13.5999 3.27002 13.5999 3.60002V12.4C13.5999 12.73 13.4824 13.0125 13.2474 13.2475C13.0124 13.4825 12.7299 13.6 12.3999 13.6H3.5999ZM3.5999 12.4H12.3999V3.60002H3.5999V12.4Z" fill="#FCFCFC"/>
  </svg>
</template>

<script>
export default {
  name: 'subworkflow-icon'
}
</script>

<style scoped>
path {
  stroke-width: 0 !important;
  fill: currentColor;
}
</style>
